import styled from 'styled-components';

export const Sheet = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #2b2b2b;
  line-height: 1.3;
`;

export const Subtitle = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: #696969;
  font-variant-numeric: tabular-nums;
`;

export const HeaderChips = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const CertBox = styled.div<{ $tone: 'ok' | 'warn' | 'bad' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid ${({ $tone }) => ($tone === 'ok' ? '#cfe9da' : $tone === 'warn' ? '#f1dea4' : '#efc5cf')};
  background: ${({ $tone }) => ($tone === 'ok' ? '#f4fbf7' : $tone === 'warn' ? '#fffaeb' : '#fdf4f6')};
`;

export const CertName = styled.strong`
  display: block;
  font-size: 13px;
  color: #2b2b2b;
  word-break: break-word;
`;

export const EnvRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const Segmented = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  border: 1px solid #d9d9d9;
  border-radius: 2rem;
  overflow: hidden;
`;

export const SegmentButton = styled.button<{ $active: boolean }>`
  height: 2.25rem;
  padding: 0 1rem;
  border: none;
  font-family: inherit;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  background: ${({ $active }) => ($active ? '#e6f3fa' : '#fff')};
  color: ${({ $active }) => ($active ? '#0090d3' : '#696969')};
  box-shadow: ${({ $active }) => ($active ? 'inset 0 0 0 2px #0090d3' : 'none')};
  border-radius: 2rem;

  &:disabled {
    color: #b5b5b5;
    cursor: not-allowed;
  }
`;

export const NumTable = styled.div`
  display: grid;
  grid-template-columns: 110px repeat(3, minmax(0, 1fr));
  gap: 8px 10px;
  align-items: center;
  font-size: 13px;
`;

export const NumHead = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #696969;
`;

export const NumLabel = styled.span`
  font-weight: 600;
  color: #4a4a4a;
`;

export const NumValue = styled.span`
  display: flex;
  align-items: center;
  height: 2.2rem;
  padding: 0 12px;
  border-radius: 2rem;
  background: #f1f1f1;
  color: #2b2b2b;
  font-variant-numeric: tabular-nums;
`;

export const NumEmpty = styled.div`
  grid-column: 2 / -1;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #696969;
`;

export const NumGatewayBox = styled.div`
  grid-column: 2 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: #4a4a4a;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`;

export const LinkButton = styled.button`
  align-self: flex-start;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  color: #0090d3;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ToggleRow = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 14px;
  color: #2b2b2b;
  cursor: pointer;
`;

export const Switch = styled.span<{ $on: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 38px;
  height: 22px;
  border-radius: 22px;
  background: ${({ $on }) => ($on ? '#0090d3' : '#c9c9c9')};
  transition: background 0.15s;

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: ${({ $on }) => ($on ? '19px' : '3px')};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.15s;
  }

  input {
    display: none;
  }
`;
